import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }
  goToHome() {
    // this.router.navigate(['/home/feed']);
    console.log('home');
  }
  goToMovies() {
    this.router.navigate(['/home/movies']);
  }
  goToTheatres() {
    this.router.navigate(['/home/theatres']);
  }
  goToBookings() {
    this.router.navigate(['/home/bookings']);
  }
  goToProfile() {
    this.router.navigate(['/home/profile']);
  }
  goToSettings() {
    this.router.navigate(['/home/settings']);
  }
}
